import { useEffect, useRef, useState } from "react"
import toast, { Toaster } from "react-hot-toast"
import { translations } from "../../../configs/translations"
import { ClientApi } from "../../../services/clientApi"
import RaceService from "../../../services/RaceService"
import { useStore } from "../../../store/store"
import { NuiMessages } from "../../../utils/ClientEvents"
import './Preparation.css'

export const Preparation = () => {

    const [visible, setVisible] = useState(false)
    const [isReady, setIsReady] = useState(false)
    const [totalPlayers, setTotalPlayers] = useState(1)
    const [readyPlayers, setReadyPlayers] = useState(1)

    const eventSourceRef = useRef<EventSource | null>(null)

    const language = useStore(state => state.language)
    const t = translations[language]

    useEffect(() => {
        ClientApi.on(NuiMessages.PREPARATION_SCREEN, ({ visible }: { visible: boolean }) => {
            setVisible(visible)

            if (!visible) {
                eventSourceRef.current?.close()
                eventSourceRef.current = null
                setIsReady(false)
                setTotalPlayers(1)
                setReadyPlayers(1)
            }
        })
    }, [])

    useEffect(() => {
        if (!visible) return

        const handleW = () => {
            window.removeEventListener('keydown', handleW)
            RaceService.ready()
                .then((data) => {
                    setIsReady(true)
                    setTotalPlayers(data.totalPlayers)
                    setReadyPlayers(data.readyPlayers)
                    connectToSSE()
                    new Audio("/sounds/race_peep.mp3").play()
                })
                .catch((error) => {
                    toast.error(
                        error && error.response && error.response.data && t[error.response.data as keyof typeof t]
                            ? t[error.response.data as keyof typeof t]
                            : t.error_unknown,
                        { className: 'notification-error' }
                    )
                })
        }

        window.addEventListener('keydown', handleW)
        return () => {
            window.removeEventListener('keydown', handleW)
            eventSourceRef.current?.close()
            eventSourceRef.current = null
        }
    }, [visible])

    const connectToSSE = () => {
        const token = localStorage.getItem('accessToken')
        const eventSource = RaceService.getRacePreparationSSE(token as string || '')
        eventSourceRef.current = eventSource

        eventSource.addEventListener("INIT", (e) => {
            console.log("Prepation SSE connected:", e.data)
        })

        eventSource.addEventListener("ADD_READY_PLAYER", () => {
            try {
                setReadyPlayers(prev => prev + 1)
            } catch (err) {
                toast.error(
                    t.error_unknown,
                    { className: 'notification-error' }
                )
            }
        })

        eventSource.onerror = () => {
            eventSource.close()
        }
    }

    if (!visible) return null

    return (
        <div className="preparation-container">
            {
                isReady ? (
                    <div className="traffic-light-container">
                        {Array.from({ length: totalPlayers }, (_, i) => (
                            <SingleTrafficLight key={i} isActive={i < readyPlayers} />
                        ))}
                    </div>
                ) :
                    <h1>{t.press_w_to_start}</h1>
            }
            <Toaster
                position="bottom-center"
                reverseOrder={false}
            />
        </div>
    )
}

export const SingleTrafficLight = ({ isActive }: { isActive: boolean }) => {
    return (
        <div className={isActive ? "traffic-light active" : "traffic-light"}></div>
    )
}
